import { Box, DialogTitleProps, Stack, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

import { AppModalOnCloseFunc, AppModalProps } from "./AppModal";

export interface AppModalActionsProps {
  modalProps: Partial<AppModalProps> | undefined;
  cancelButton?: ReactNode;
  submitButton?: ReactNode;
  isAutoCloseOnCancel?: boolean;
  isAutoCloseOnSubmit?: boolean;
  sx?: SxProps<Theme>;
  children?: DialogTitleProps["children"];
  onClose?: AppModalOnCloseFunc;
}

export default function AppModalActions({
  modalProps,
  cancelButton,
  submitButton,
  isAutoCloseOnCancel = true,
  isAutoCloseOnSubmit = false,
  sx,
  children,
  onClose,
}: AppModalActionsProps) {
  const close = () => {
    if (onClose) {
      onClose(undefined, "childClose");
    } else if (modalProps?.onClose) {
      modalProps.onClose(undefined, "childClose");
    }
  };

  return (
    <Stack
      direction={{ xxs: "column", md: "row" }}
      gap={1}
      sx={{
        m: 0,
        p: 0,
        justifyContent: { xxs: "flex-start", md: "flex-end" },
        alignItems: { xxs: "flex-start", md: "flex-start" },
        ...sx,
      }}
    >
      {children}

      {cancelButton && (
        <Box sx={{ display: "flex" }} onClick={() => isAutoCloseOnCancel && close()}>
          {cancelButton}
        </Box>
      )}

      {submitButton && (
        <Box sx={{ display: "flex" }} onClick={() => isAutoCloseOnSubmit && close()}>
          {submitButton}
        </Box>
      )}
    </Stack>
  );
}
